import { getDateString } from "../../css/Utility";

function StatusBadge({ status }) {
  const closed = (status || '').toLowerCase() === 'closed';
  return (
    <span className={`tv-badge tv-badge--${closed ? 'closed' : 'open'}`}>
      {status}
    </span>
  );
}

export function TicketHeader({ data }) {
  return (
    <div className="tv-header">
      <div className="tv-header-top">
        <h3 className="tv-subject">{data.subject}</h3>
        <StatusBadge status={data.status} />
      </div>
      <div className="tv-meta">
        <span className="tv-meta-item"><strong>ID</strong> #{data.id}</span>
        <span className="tv-meta-sep" aria-hidden="true">·</span>
        <span className="tv-meta-item"><strong>Character</strong> {data.character}</span>
        <span className="tv-meta-sep" aria-hidden="true">·</span>
        <span className="tv-meta-item"><strong>Opened</strong> {getDateString(data.timestamp)}</span>
      </div>
    </div>
  );
}
